import { Input, Skeleton, Table } from 'antd';
import API from 'API';
import React, { useEffect, useState } from 'react';
import dayjs from "dayjs";
import "./style.css";
import TermHandle from './TermHandle';
import { getScoreColor } from '../../StudentSide/StudentCalendar/style_const';
import { useMask } from 'App';
import EnrollStudent from './EnrollStudent';
const { Search } = Input;

const NOW = dayjs();

const courseColumns = [
    {title: "Môn học", dataIndex: "name", key: "name"},
    {title: "Ngành học", dataIndex: "majors", key: "majors", render: (value) => value.map(item=><React.Fragment key={item.id}>{item.name} <br/></React.Fragment>)},
    {title: "Số lượng sinh viên", dataIndex: "numbers_of_students", key: "numbers_of_students"},
    {title: "Số lượng qua môn", dataIndex: "numbers_of_passed", key: "numbers_of_passed"},
    {title: "Tỷ lệ qua môn", key: "percent_of_passed", render: (value) => {
        const result = value.numbers_of_students && (Math.round(value.numbers_of_passed*100/value.numbers_of_students));
        return <span style={{
            color: getScoreColor(result*10)
        }}>
            {result}%
        </span>
    }},
]

export default function UniversityTerms() {
    const [terms, setTerms] = useState(null);
    const [selectedTerm, setSelecterdTerm] = useState(null);
    const [loading, setLoading] = useState(true);
    const [courses, setCourses] = useState([]);
    const [coursesPage, setCoursesPage] = useState(1);
    const [searchCourses, setSearchCourses] = useState("");
    const { setFullMask } = useMask();
    useEffect(() => {
        async function getData() {
            try {
                const response = await API.get("/terms/", {
                    params: {
                        page_size: 1000
                    }
                });
                var check = false;
                for (const r of response.data.results) {
                    r.start_time = dayjs(r.start_time);
                    r.end_time = dayjs(r.end_time);
                    r.start_week = dayjs(r.start_week);
                    if (r.register_start_time) r.register_start_time = dayjs(r.register_start_time);
                    if (r.register_end_time) r.register_end_time = dayjs(r.register_end_time);
                    if (!check) {
                        if (r.start_time.isBefore(NOW) && r.end_time.isAfter(NOW)) {
                            check = true;
                            setSelecterdTerm(r);
                        }
                    }
                }
                if (!check) {
                    setSelecterdTerm(response.data.results[0] || null);
                }
                setTerms(response.data.results);
                setLoading(false);
            } catch (e) {
                console.log(e);
            } finally {

            }
        }
        getData();
    }, [])

    useEffect(()=>{
        if (!selectedTerm) {
            setCourses([]);
            return;
        }
        async function getData() {
            setFullMask(true);
            try {
                const response = await API.post(`/course-term/?page=${coursesPage}`, {
                    term_id: selectedTerm.id, name: searchCourses
                });
                setCourses(response.data);
            } catch (e) {
                console.log(e);
            } finally {
                setFullMask(false);
            }
        }
        getData();
    },[selectedTerm, coursesPage, setFullMask, searchCourses])
    
    return loading ? <Skeleton active /> : <>
        <h5>Chọn kỳ:</h5>
        <TermHandle terms={terms} setTerms={setTerms}
            selectedTerm={selectedTerm} setSelecterdTerm={(v)=>{
                setCoursesPage(1);
                setSelecterdTerm(v);
            }} />
        <div style={{ marginBottom: 5 }}>
            <Search allowClear placeholder="Tìm môn học" onSearch={(v) => {
                setCoursesPage(1);
                setSearchCourses(v);
            }}/>
        </div>
        <Table 
            dataSource={courses.results}
            columns={courseColumns}
            rowKey="id"
            pagination={{
                total: courses.count,
                current: coursesPage,
                showSizeChanger: false,
                pageSize: 10,
                onChange: setCoursesPage
            }}
            expandable={{
                expandedRowRender: (record, index, indent, expanded)=>
                    expanded && <EnrollStudent course={record} setCourses={setCourses} term={selectedTerm}/>
            }}
        />
    </>
}
